import React from "react";
import 'swiper/css';
import 'swiper/css/pagination';
import {BaseFragment, BaseFragmentProps, BaseFragmentState} from "../shared/BaseFragment";
import {StyledEmpty} from "../shared/StyledComponents";
import {Book, Smilebook} from "../smilebook-shared/types";
import {Preview} from "@/smilebook-shared/components/Preview";

export type MainProps = BaseFragmentProps & {}

type MainState = BaseFragmentState & {
  book: Book,
}

export class Main extends BaseFragment<MainProps, MainState> {

  protected async fetchOnMount(forceReload?: boolean): Promise<any> {
    const urlParams = new URLSearchParams(window.location.search);
    const practiceId = urlParams.get("id");
    if (practiceId) {
      await Smilebook.loadInstance(practiceId);
      this.setState({
        book: Smilebook.getInstance().published?.book,
      });
    }
  }

  protected renderContainerContent(): React.ReactElement | null {
    const book = this.state.book;
    if (!book) {
      return <StyledEmpty emptyConfig={{
        iconUrl: "/images/error.svg",
        title: "There was an error loading your Smilebook",
        text: "Please check the url and try again.",
      }}/>;
    }
    return <Preview book={book} />;
  }
}